import { InternalAxiosRequestConfig } from 'axios';

import { TRACE_HEADER_NAME } from '@app/consts/consts';

import { context, propagation, trace } from '@opentelemetry/api';

const onOpenTelemetryInterceptor = (
    request: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
    request.headers = request.headers || {};
    propagation.inject(context.active(), request.headers);

    const span = trace.getActiveSpan();
    const traceId = span?.spanContext().traceId;
    if (traceId) {
        request.headers['x-trace-id'] = traceId;
        request.headers[TRACE_HEADER_NAME] = span?.spanContext().spanId;
    }

    return request;
};

export const requestInterceptors = { onOpenTelemetryInterceptor };
